import React from 'react';
import LoginForm from './LoginForm.jsx';
import {Image} from "semantic-ui-react";
import ForgotPasswordModalContainer from 'pages/Login/ForgotPasswordModalContainer';

const LoginPage = (props) => (
  <div className="login-modal">
    <ForgotPasswordModalContainer/>
    <div className="beaker-login">
      <Image centered src="https://s3.amazonaws.com/beaker-tooltips/beaker-logo-icon-final+(1).svg"/>
    </div>
    <h1>Login</h1>
    <LoginForm/>
  </div>
)

export default LoginPage;



// WEBPACK FOOTER //
// ./public/pages/Login/LoginPage.jsx